import * as React from "react";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { Translations } from "ui/Scripts/source/models/translations";
import { Box, Divider, Tooltip, Typography } from "@mui/material";
import { SectionIcon, SectionType } from "source/components/framework/Icon/SectionIcon";
import { AppReportTaskTypeEventReference } from "ui/Scripts/source/models/appReportTemplate/appReportTaskTypeEventReference";
import { TaskDynamicFormReferenceWarning } from "./TaskDynamicFormReferenceWarning";
import { Base } from "ui/Scripts/source/framework/base";

interface ITaskDynamicFormEventReferenceProp {
    taskTypeCol: ITaskTypeCol;
}

export const TaskDynamicFormEventReference = (props: ITaskDynamicFormEventReferenceProp) => {
    const eventReference = new AppReportTaskTypeEventReference(props.taskTypeCol.objectValue);

    return (
        <>
            <Divider sx={{
                "maxWidth": "100%",
                "overflow": "hidden",
                "&::before, &::after": {
                    borderColor: "#000"
                }
            }}>
                <Box sx={{ padding: "8px 0" }}>
                    <Tooltip title={eventReference.name}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <SectionIcon sx={{ marginRight: "8px" }} type={SectionType.Events} />
                            <span>{Translations.FormEventReference}: </span>
                            <Box component="span" marginLeft="5px">
                                {(eventReference.reportId && eventReference.chartId
                                    ? eventReference.name
                                    : <Typography color="red">{"'" + Translations.NotSelected + "'"}</Typography>
                                )}
                            </Box>
                        </Box>
                    </Tooltip>
                </Box>
            </Divider>
            {!(eventReference.reportId && eventReference.chartId) &&
                <TaskDynamicFormReferenceWarning
                    message={String.format(Translations.FormEventReferenceWarning,
                        Base.getStringWithSeparators([
                            eventReference.reportId ? null : Translations.Report,
                            eventReference.chartId ? null : Translations.ChartOrTableType
                        ], ", "))}
                />
            }
        </>
    );
};